import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendProject,
  BackendProjectContinuousOptimizationSegmentArgs,
  BackendQueryProjectArgs,
} from 'src/types/backend';

import { FRAGMENT_CO_ASSET } from './schema';

const QUERY = gql`
  query AudienceSegmentAssets($projectId: Int!, $segmentId: ID) {
    project(id: $projectId) {
      id

      continuousOptimizationSegment(id: $segmentId) {
        landingPageAssets {
          ...LandingPageAsset
        }
        keywords
      }
    }
  }
  ${FRAGMENT_CO_ASSET}
`;

type Variables = {
  projectId: BackendQueryProjectArgs['id'];
  segmentId?: BackendProjectContinuousOptimizationSegmentArgs['id'];
};

export const queryAudienceSegmentAssets = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  const project = getSingleProp<BackendProject>(result.data);
  const segment = project?.continuousOptimizationSegment?.[0];
  return {
    assets: segment?.landingPageAssets ?? [],
    keywords: segment?.keywords ?? [],
  };
};
